module.exports = __webpack_public_path__ + "static/media/phone.89c7b3ff.svg";